export default __webpack_public_path__ + "static/media/ilustracao-atas-assembleias.8f48f1eb.svg";